require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-3-options-for-product-customisation-in-shopify.json") })
        }
      }, "path---blog-3-options-for-product-customisation-in-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-3-options-for-product-customisation-in-shopify!./.cache/json/blog-3-options-for-product-customisation-in-shopify.json
// module id = 389
// module chunks = 231608221292675